<template lang="html">

  <div class="wrapper politica">

    <section class="intro politica column-center">

      <h1 class="big-title column-center">
        <span>Política de privacidad</span>
      </h1>

    </section>


    <div class="container legal">

      <h2>RESPONSABLE</h2>

      <p>El Responsable del Tratamiento es la Diputación Provincial de Jaén, Plaza de San Francisco s/n 23071 – Jaén,
        siendo el representante su Presidente. Conforme a lo dispuesto en el artículo 37 del REGLAMENTO (UE) 2016/679
        DEL PARLAMENTO EUROPEO Y DEL CONSEJO de 27 de abril de 2016, se ha designado al órgano de esta Diputación
        Provincial: Secretaría General, como Delegado de Protección de Datos. Para el ejercicio de los derechos
        previstos en el mismo, podrá contactar a través de  la dirección de correo electrónico: dpd@dipujaen.es (esta
        dirección de correo electrónico estará disponible, exclusivamente, para consultas relacionadas con la protección
        de datos).</p>

      <h2>FINALIDAD DEL TRATAMIENTO</h2>

      <p>Los datos se utilizarán para la organización de las actividades en las que se inscriban del programa “A Jaén al
        paraíso”: elaboración del listado de participantes, comunicación de cualquier novedad sobre dicho evento,
        comprobación de asistencia. Además los datos se incluirán en la plataforma electrónica para la gestión unificada
        de la provincia de Jaén con la finalidad de utilizarla para el envío de información turística de la provincia y
        sobre organización de actividades promocionales.</p>

      <h2>LEGITIMACIÓN</h2>

      <p>Conforme a lo previsto en el artículo 6 del REGLAMENTO (UE) 2016/679 DEL PARLAMENTO EUROPEO Y DEL CONSEJO de 27
        de abril de 2016 y en el artículo 6 de la Ley orgánica 3/2018, de 5 de diciembre, de Protección de Datos
        Personales y garantía de los derechos digitales. el tratamiento encuentra su base de legitimación en:</p>
      <p>a) el interesado dio su consentimiento para el tratamiento de sus datos personales para esta finalidad.</p>
      <p>
        El interesado da su consentimiento expreso a facilitar los datos a que se refiere el presente formulario para la
        organización de la actividad y para que la Diputación Provincial de Jaén, pueda enviar información de promoción
        turística de la provincia.
      </p>

      <h2>
        DESTINATARIOS DE CESIONES O TRANSFERENCIAS
      </h2>

      <p>Los datos se cederán exclusivamente a las entidades encargadas de la gestión de las reservas y la organización
        y coordinación de las actividades, de manera que sea posible organizar las actividades garantizando la
        participación de las personas inscritas.</p>

      <h2>DERECHOS</h2>

      <p>En cualquier momento el interesado podrá ejercer los derechos recogidos en los artículos 15 y siguientes del
        Reglamento (UE) 2016/379, de 27 de abril de 2016, sí como los señalados en el artículo 12 y siguientes de la Ley
        orgánica 3/2018, de 5 de diciembre, de Protección de Datos Personales y garantía de los derechos digitales,
        mediante la presentación de escrito en el Registro Electrónico General. Estos derechos son los que a
        continuación se indican:</p>
      <p>Derecho a obtener del responsable del tratamiento confirmación de si se están o no tratando datos personales
        que le conciernen y, en tal caso derecho de acceso a los mismos y, a la siguiente información: los fines del
        tratamiento, categorías de datos personales que se traten y de las posibles comunicaciones de datos y sus
        destinatarios. De ser posible, ser informado del plazo de conservación de sus datos. De no ser posible, los
        criterios para determinar este plazo. </p>
      <p>Derecho a obtener sin dilación indebida la rectificación de los datos personales inexactos que le conciernan y,
        en caso de ser incompletos a que se completen, inclusive mediante una declaración adicional. </p>
      <p>Derecho de supresión de los datos personales sin dilación indebida en los supuestos contemplados en el artículo
        17, salvo las excepciones recogidas en el mismo.</p>
      <p>Derecho a la limitación del tratamiento, que comprende: El derecho a solicitar la suspensión del tratamiento
        cuando; 1. Se impugne la exactitud de los datos, mientras se verifica dicha exactitud por el responsable. 2. El
        interesado ha ejercitado su derecho de oposición, mientras se verifica si los motivos legítimos del responsable
        prevalecen sobre el afectado. El derecho a solicitar la conservación de los datos personales cuando; 1. El
        tratamiento sea ilícito y el afectado se oponga a la supresión de sus datos y solicite en su lugar la limitación
        de su uso. 2. El responsable ya no necesita los datos para los fines del tratamiento pero el afectado si los
        necesita para la formulación, ejercicio o defensa de reclamaciones. </p>
      <p>Derecho a la portabilidad de sus datos, es decir, derecho a recibir los datos personales que le incumban y que
        haya facilitado al responsable del tratamiento, en un formato estructurado, de uso común y lectura mecánica y, a
        transmitirlos a otro responsable del tratamiento sin que pueda impedirlo el responsable al que se los hubiera
        facilitado en los casos que dispone el artículo 20, siempre y cuando no afecte negativamente a los derechos y
        libertades de otros. </p>
      <p>Derecho a oponerse en cualquier momento, por motivos relacionados con su situación particular y personal, a que
        datos personales que le conciernan sean objeto de tratamiento salvo que se acredite un interés legítimo o, sea
        necesario para el ejercicio o defensa de reclamaciones. Derecho a oponerse al tratamiento cuando este tenga por
        objeto la mercadotecnia directa.</p>
      <p>Recibida la solicitud de cualquiera de las actuaciones anteriores, la Diputación de Jaén responderá en el plazo
        de un mes a partir de la recepción de la misma. No obstante, dicho plazo podrá ampliarse otros dos meses en caso
        necesario, teniendo en cuenta la complejidad y el número de solicitudes. En este caso, se informará al ciudadano
        de la citada prórroga en el plazo de un mes a partir de la recepción de la solicitud, indicando los motivos de
        la dilación. Si el ciudadano presentase la solicitud por medios electrónicos, la información se facilitará por
        medios electrónicos cuando sea posible, a menos que este solicite que se facilite por otro medio. </p>
      <p>En caso de considerar vulnerado su derecho a la protección de datos personales, podrá interponer una
        reclamación ante el Consejo de Transparencia y Protección de Datos de Andalucía. </p>


    </div>

  </div>

</template>

<script lang="js">
  export default {
    name: 'politica-de-privacidad',
    props: [],
    mounted() {

    },
    data() {
      return {

      }
    },
    methods: {

    },
    computed: {

    }
  }
</script>

<style scoped lang="scss">
  .politica-de-privacidad {}
</style>


// WEBPACK FOOTER //
// src/components/views/politica-de-privacidad.vue